import { render, staticRenderFns } from "./GalleryAdd.vue?vue&type=template&id=29220c5b&scoped=true"
import script from "./GalleryAdd.vue?vue&type=script&lang=js"
export * from "./GalleryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29220c5b",
  null
  
)

export default component.exports